import React, { useEffect, useMemo } from "react";
import { BlockProps } from "@companion-core/shared/app/Interfaces/blocks";
import { APICardComponent, ComponentData } from "@companion-core/shared/app/Interfaces/API";
import {
  getComponentsCard,
  getComponentsFromBlockItems,
  getComponentText,
} from "@companion-core/shared/app/Utils/componentHelper";
import { useTabContainerStore } from "@companion-core/shared/app/Store/tabContainerStore";
import { TabLayout } from "@companion-core/shared/app/Components/Blocks/Layouts/TabLayout";

export const Tab = ({ simpleBlockItems, contentProps }: BlockProps) => {
  const { addTab, removeTab } = useTabContainerStore((state) => ({
    addTab: state.addTab,
    removeTab: state.removeTab,
  }));
  const simpleComponents: ComponentData[] = useMemo(
    () => getComponentsFromBlockItems(simpleBlockItems),
    [simpleBlockItems]
  );
  const title: string = useMemo(
    () => getComponentText(simpleComponents)?.title ?? "",
    [simpleComponents]
  );
  const cards: APICardComponent[] = useMemo(
    () => getComponentsCard(simpleComponents),
    [simpleComponents]
  );
  const isInTabContainer = useMemo(() => contentProps.isInContainer ?? false, [contentProps]);

  useEffect(() => {
    if (isInTabContainer) {
      addTab({
        title: title,
        slug: contentProps.slug,
        cards: cards,
        order: contentProps.order ?? 0,
      });
    }
    return () => {
      if (isInTabContainer) {
        removeTab(contentProps.slug);
      }
    };
  }, []);

  return <TabLayout cards={cards} />;
};
